// Web module: trust (lane L4). Trust Center admin, replacing the SafeBase admin: Editor (cards and items), Access
// requests, Accounts and members, Documents, Updates and subscribers, Knowledge base, Subprocessors, NDA templates and
// signed NDAs, Analytics and Settings, all under /trust. Every entity keeps its generic detail page (history, revert,
// notes) at /<plural>/<id>. The contract is in ../README.md.
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { appRoute } from '../../app/route-base'
import { lazyComponent } from '../../lib/lazy'
import type { WebModule } from '../../lib/modules'

export const trustRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/trust',
  component: lazyRouteComponent(() => import('./TrustLayout'), 'TrustLayout'),
})

const editorRoute = createRoute({
  getParentRoute: () => trustRoute,
  path: '/',
  component: lazyRouteComponent(() => import('./EditorPage'), 'EditorPage'),
})
const requestsRoute = createRoute({
  getParentRoute: () => trustRoute,
  path: 'requests',
  component: lazyRouteComponent(() => import('./RequestsPage'), 'RequestsPage'),
})
const accountsRoute = createRoute({
  getParentRoute: () => trustRoute,
  path: 'accounts',
  component: lazyRouteComponent(() => import('./AccountsPage'), 'AccountsPage'),
})
const documentsRoute = createRoute({
  getParentRoute: () => trustRoute,
  path: 'documents',
  component: lazyRouteComponent(() => import('./DocumentsPage'), 'DocumentsPage'),
})
const updatesRoute = createRoute({
  getParentRoute: () => trustRoute,
  path: 'updates',
  component: lazyRouteComponent(() => import('./UpdatesPage'), 'UpdatesPage'),
})
const kbRoute = createRoute({
  getParentRoute: () => trustRoute,
  path: 'knowledge-base',
  component: lazyRouteComponent(() => import('./ContentPages'), 'KnowledgeBasePage'),
})
const subprocessorsRoute = createRoute({
  getParentRoute: () => trustRoute,
  path: 'subprocessors',
  component: lazyRouteComponent(() => import('./ContentPages'), 'SubprocessorsPage'),
})
const ndaRoute = createRoute({
  getParentRoute: () => trustRoute,
  path: 'nda',
  component: lazyRouteComponent(() => import('./NdaPage'), 'NdaPage'),
})
const analyticsRoute = createRoute({
  getParentRoute: () => trustRoute,
  path: 'analytics',
  component: lazyRouteComponent(() => import('./AnalyticsPage'), 'AnalyticsPage'),
})
const settingsRoute = createRoute({
  getParentRoute: () => trustRoute,
  path: 'settings',
  component: lazyRouteComponent(() => import('./SettingsPage'), 'SettingsPage'),
})

export const module: WebModule = {
  routes: [
    trustRoute.addChildren([
      editorRoute,
      requestsRoute,
      accountsRoute,
      documentsRoute,
      updatesRoute,
      kbRoute,
      subprocessorsRoute,
      ndaRoute,
      analyticsRoute,
      settingsRoute,
    ]),
  ],
  entityOverrides: {
    // The plain list of cards is the editor; old links to /trust-sections land there.
    trust_section: { ListPage: lazyComponent(() => import('./TrustLayout'), 'TrustSectionsRedirect') },
    trust_access_request: { ListPage: lazyComponent(() => import('./TrustLayout'), 'TrustRequestsRedirect') },
  },
  nav: [
    {
      key: 'trust',
      label: 'Trust Center',
      to: '/trust',
      group: 'Trust',
      order: 10,
      icon: 'trust',
      entity: 'trust_section',
      module: 'trust',
    },
  ],
}
